import { Avatar, AvatarGroup, Box, ImageList, ImageListItem, Typography } from '@mui/material'
import React from 'react'
import CachedIcon from '@mui/icons-material/Cached';
// import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
// import Avatar from '@mui/material/Avatar';
// import Typography from '@mui/material/Typography';

export const Rightbar = () => {
  return (
    <Box flex={2} width={300} padding={2} sx={{display : {xs:"none", sm : "block"}}} >
    
    <Box position="fixed"> 

 
    <Typography  variant='h6'>Online Users</Typography>
    <AvatarGroup max={7}>
  <Avatar alt="Remy Sharp" src="https://picsum.photos/200" />
  <Avatar alt="Travis Howard" src="https://picsum.photos/200" />
  <Avatar alt="Cindy Baker" src="https://picsum.photos/200" />
  <Avatar alt="Agnes Walker" src="https://picsum.photos/200" />
  <Avatar alt="Trevor Henderson" src="https://picsum.photos/200" />
  <Avatar alt="Remy Sharp" src="https://picsum.photos/200" />
  <Avatar alt="Travis Howard" src="https://picsum.photos/200" />
  <Avatar alt="Cindy Baker" src="https://picsum.photos/200" />
  <Avatar alt="Agnes Walker" src="https://picsum.photos/200" />
  
  
</AvatarGroup>

<Typography  variant='h6' mt={2} mb={2}>New Posts <CachedIcon/> </Typography>

<ImageList cols={3} rowHeight={100} gap={5}> 
    <ImageListItem>
        <img
            src = "https://picsum.photos/200"
            alt= "Error Loading image"
        />
    </ImageListItem>
    <ImageListItem>
        <img
            src = "https://picsum.photos/200"
            alt= "Error Loading image"
        />
    </ImageListItem>
    <ImageListItem>
        <img
            src = "https://picsum.photos/200"
            alt= "Error Loading image"
        />
    </ImageListItem>
    
</ImageList>
    

    <Typography  variant='h6' mt={2} >Latest Conversations </Typography>
    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
        </ListItemAvatar>
        <ListItemText
          primary="Brunch this weekend?"
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: 'inline' }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                Ali Connors
              </Typography>
              {" — I'll be in your neighborhood doing errands this…"}
            </React.Fragment>
          }
        />
      </ListItem>
      <Divider variant="inset" component="li" />
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />
        </ListItemAvatar>
        <ListItemText
          primary="Summer BBQ"
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: 'inline' }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                to Scott, Alex, Jennifer
              </Typography>
              {" — Wish I could come, but I'm out of town this…"}
            </React.Fragment>
          }
        />
      </ListItem>
      <Divider variant="inset" component="li" />
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />
        </ListItemAvatar>
        <ListItemText
          primary="Oui Oui"
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: 'inline' }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                Sandra Adams
              </Typography>
              {' — Do you have Paris recommendations? Have you ever…'}
            </React.Fragment>
          }
        />
      </ListItem>
    </List>
    </Box>
    </Box>
  )
}
